module.exports = __webpack_public_path__ + "media/home/plan-feature-premium-21c567f7.jpg";